import type { PopoverOrigin, SxProps, Theme } from "@mui/material";
import { Menu, ThemeProvider } from "@mui/material";
import type { JSX, PropsWithChildren } from "react";
import { cloneElement, useState } from "react";

interface PopupMenuProps {
  anchor: JSX.Element;
  transformOrigin?: PopoverOrigin;
  anchorOrigin?: PopoverOrigin;
  paperProps?: SxProps<Theme> | undefined;
  theme: Theme;
}

const PopupMenu = ({
  anchor,
  children,
  transformOrigin,
  anchorOrigin,
  paperProps,
  theme,
}: PropsWithChildren<PopupMenuProps>) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const isOpen = !!anchorEl;

  return (
    <>
      {cloneElement(anchor, { onClick: handleClick })}
      <ThemeProvider theme={theme}>
        <Menu
          anchorEl={anchorEl}
          open={isOpen}
          onClose={handleClose}
          onClick={handleClose}
          transformOrigin={transformOrigin}
          anchorOrigin={anchorOrigin}
          slotProps={{
            paper: {
              elevation: 0,
              sx: paperProps,
            },
          }}
        >
          {children}
        </Menu>
      </ThemeProvider>
    </>
  );
};

export default PopupMenu;
